import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./services.css";
import { useAppContext } from "../../context/app-context";

const services = [
  { name: "Artificial Intelligence", url: "/services/artificial_intelligence" },
  { name: "Web Application Development", url: "/services/web_app" },
  { name: "Blockchain Applications", url: "/services/blockchain_app" },
  { name: "Machine Learning", url: "/services/machine_learning" },
  { name: "Internet of Things(IoT)", url: "/services/iot_app" },
  { name: "Android Mobile App Development", url: "/services/android_app" },
  {
    name: "Robotic Process Automation",
    url: "/services/robotic_process_automation",
  },
  { name: "IOS Mobile App Development", url: "/services/ios_app" },
  { name: "Business Intelligence", url: "/services/business_intelligence" },
  { name: "Cloud", url: "/services/cloud_strategy" },
];

const Services = ({ isMegaMenu }) => {
  const navigate = useNavigate();
  const { setSelectedNavItem, setTempSelectedTitle } = useAppContext();

  const handleClickService = (url) => {
    navigate(url);
    window.scrollTo(0, 0);
    setSelectedNavItem("services");
    setTempSelectedTitle("");
  };

  return (
    <>
      <section
        className={`services-section ${isMegaMenu ? "mega-menu-content" : ""}`}
      >
        <Container fluid>
          <Row>
            <Col xs="12" lg="7">
              <div className="d-flex gap-0 gap-lg-4 flex-wrap">
                <ul className="services-list list-unstyled">
                  {services.slice(0, 6).map((service, index) => (
                    <li key={index}>
                      <Button
                        variant="link"
                        onClick={() => handleClickService(service.url)}
                      >
                        {service.name}
                      </Button>
                    </li>
                  ))}
                </ul>
                <ul className="list-unstyled services-list">
                  {services.slice(6).map((service, index) => (
                    <li key={index + 6}>
                      <Button
                        variant="link"
                        onClick={() => handleClickService(service.url)}
                      >
                        {service.name}
                      </Button>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Services;
